import React, { useState } from "react";
import img from "./img/IMG20251011164916.80be2c9269f3f7fd26cd.webp";
import "./style.css"; // можно убрать, если всё перенесёшь в tailwind

function FAQSection() {

  return (
    <div className="py-20 bg-gradient-to-b from-gray-900 via-black to-gray-950">
      {/* Жалпы контейнер */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-20">
          <h1
            className="
        text-4xl sm:text-5xl md:text-6xl lg:text-7xl 
        font-black tracking-tight
        bg-gradient-to-r from-white via-[#A1C349] to-[#E8F5B8]
        bg-clip-text text-transparent
        drop-shadow-2xl
      "
          >
            СТОЛДОР — САПАТТЫН СИМВОЛУ
          </h1>

          <p className="mt-5 text-xl md:text-2xl text-gray-300 font-light max-w-4xl mx-auto">
            Кыргыз усталарынан өзгөчө столдор — үйүңүзгө ылайыкталган
          </p>
        </div>

        {/* ─────────────── Раздел ОРУНДУКТАР ─────────────── */}
        <div className="relative overflow-hidden rounded-3xl md:rounded-4xl shadow-2xl">
          {/* Фон */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${img})`,
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/60 to-black/35" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#A1C349]/5 via-transparent to-[#A1C349]/3" />
          </div>

          <div className="relative px-6 py-16 md:py-24 lg:py-32 text-center z-10">
            <h2
              className="
          text-4xl md:text-5xl lg:text-6xl font-extrabold
          bg-gradient-to-r from-white via-[#A1C349] to-white
          bg-clip-text text-transparent mb-8 md:mb-12
        "
            >
              Столдун узундугуна жараша стулдардын саны — идеалдуу жайлуулук
              үчүн:
            </h2>

            <p className="text-lg md:text-xl lg:text-2xl text-gray-200 max-w-4xl mx-auto mb-16 font-light">
              Ар бир өлчөм — конокторуңузга ыңгайлуулук, үйүңүзгө көрк жана
              өзгөчө атмосфера тартуулайт.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 md:gap-7">
              {[
                ["2.5 метр стол", "12"],
                ["3 метр стол", "14"],
                ["3.5 метр стол", "16"],
                ["4 метр стол", "18"],
                ["4.5 метр стол", "20"],
                ["5 метр стол", "20–22"],
                ["5.5 метр стол", "22"],
                ["6 метр стол", "24"],
                ["6.5 метр стол", "26"],
                ["7+ метр стол", "28+"],
              ].map(([len, chairs], i) => (
                <div
                  key={i}
                  className="
                group relative
                bg-white/10 backdrop-blur-xl
                border border-white/15 rounded-2xl
                p-7 md:p-9
                transition-all duration-500
                hover:scale-[1.06] hover:shadow-[0_0_35px_rgba(161,195,73,0.3)]
                hover:border-[#A1C349]/50
              "
                >
                  <div className="text-4xl md:text-5xl font-black text-white group-hover:text-[#A1C349] transition-colors">
                    {len}
                  </div>

                  <div className="mt-4 text-3xl md:text-4xl font-bold text-[#E8F5B8]">
                    {chairs}
                  </div>

                  <div className="mt-2 text-lg md:text-xl text-gray-300">
                    стул
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Финальная подпись */}
        <div className="text-center mt-20 md:mt-32 text-gray-400 text-lg md:text-xl italic">
          Кыргызстанда жасалган сапаттуу столдор — үйүңүздүн көркү,
          конокторуңуздун сыймыгы.
        </div>
      </div>
    </div>
  );
}

export default FAQSection;
